import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { Auth, GoogleAuthProvider, OAuthProvider, signOut, signInWithPopup, onIdTokenChanged, getAuth } from '@angular/fire/auth';
import { signInWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification } from '@angular/fire/auth';


import { UtilsService } from '../utils/utils.service';
import { LanguageService } from '../language/language.service';


@Injectable({
  providedIn: 'root'
})
export class UserAuthenticationService {

  private auth = inject(Auth)
  private googleAuth = inject(GoogleAuthProvider)


  // Observable that indicates if the user is logged in or not to other services or components
  private userIsLoggedBehaviorSubject: BehaviorSubject<boolean> 

  // Custom variables to control the user state
  private _currentUser:any = null
  private _lastLogin:number|null = null

  // Internal variable to controll if the user is loging out
  private _userIsLogingOut:boolean = false

  constructor(
    public utilsService:UtilsService,
    public languageService:LanguageService
  ) {
    this.userIsLoggedBehaviorSubject = new BehaviorSubject<boolean>(false)
   }


   async loginWithProvider(){
    try{
      // Login with Google provider
      const result = await signInWithPopup(this.auth, this.googleAuth)    
      // Get the current user
      const currentUser = result!.user
      // Get the custom claims. Validate them and store the necessary values (role, region, gateways and policy)
      const resultDict = await this.validateAndStoreCustomClaims(currentUser)
      if(!resultDict['resultOk']) return resultDict
      // Store the current user information
      this._currentUser = currentUser  
      // Set on change listeners
      this.monitorTokenRevocation()
      // Set user as logged
      this.setUserIsLoggedValue(true); 
      // Finish
      return {resultOk:true}
    }catch(error) {
      // Errors from the custom process
      // Needs to logout
      this.logout()
      // Finish
      return {resultOk:false, error:error}
    }  
   }


   async logout(){
    // Store that the user is loging out on his own
    this._userIsLogingOut = true
    try {
      // Sing out the user
      await signOut(this.auth);
      // Set user as not logged
      //this.setUserIsLoggedValue(false); 
    } catch (error) {}
    // Clear the class variables
    this._currentUser = null
  }



  // ----- Token Revocation Monitoring ----- //
   
  private monitorTokenRevocation() {
    const authInstance = getAuth();
    // Escuchar cambios en el token
    onIdTokenChanged(authInstance, async (user) => {
      // This is trigger when the user is logged out (intentionally or due to token invalidation)
      if (!user) {
        // If it is a logout due to another session starting, notify the user
        if(!this._userIsLogingOut){
          // TODO: TBD
          /*
          let popupTitle = this.languageService.Strings.popups.title_sessionClosed
          let popupText = this.languageService.Strings.popups.text_sessionClosed
          this.utilsService.displayInformationPopupComponent(popupTitle, popupText)
          */
        }
        // Notify all the components that the user is logged out and finish
        return this.setUserIsLoggedValue(false);
      }
      // This is trigger when the token or claims change (due to time or backend actions)
      // The method gets the new token and updates the claims if possible.
      // If the user is not able to get the token, logout
      try {
        // TODO: TBD - Manage error (Check that it is not repeated with the previous step in this same method)
        const resultDict = await this.validateAndStoreCustomClaims(user)
      } catch (error) {
        this.logout();
      }
    });
  }


  // ----- Custom claims management ------ //

  // Validate and store custom claims
  async validateAndStoreCustomClaims(user:any){
    const idTokenResult = await user.getIdTokenResult(true);
    const customClaims = idTokenResult.claims
    return {resultOk:true}
  }



  // ------ User is logged observable ----//

  // Methods to subscribe to user logged value
  setUserIsLoggedValue(newValue:boolean): void {
    this.userIsLoggedBehaviorSubject.next(newValue);
  }
  getUserIsLoggedValue(): Observable<boolean> {
    return this.userIsLoggedBehaviorSubject.asObservable();
  }




  // ------ Methods to access privat evariables ------ //

  // User variables 
  //  Id Token
  async getUserIdToken(forceRefresh:boolean=true): Promise<string> {
    if (this._currentUser) {
      return await this._currentUser.getIdToken(forceRefresh);
    }
    return '';
  }
  //  User email
  getUserEmail(): string{
    return this._currentUser.email;
  }
  //  User code ("email until @")
  getUserCode(): string{
    const userEmail = this._currentUser.email;
    const parts = userEmail.split('@');
    return parts[0];
  }

  // Last login
  setLastLogin(lastLogin:number|null){
    this._lastLogin = lastLogin
  }
  getLastLogin(){
    return this._lastLogin
  }

}
